(() => {
  if (window.sykCreatorFilms) return;
  const instances = new Map();
  let dialog, player, lastTrigger, backgrounds = [], scrollLocked = false, previousOverflow = '';
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function stopPlayer() {
    if (!player) return;
    player.pause();
    player.removeAttribute('src');
    player.load();
  }
  function closePlayer() { if (dialog?.open) dialog.close(); }
  function restorePage() {
    stopPlayer();
    if (scrollLocked) document.documentElement.style.overflow = previousOverflow;
    scrollLocked = false;
    backgrounds.forEach(video => { if (document.contains(video) && !document.hidden) video.play().catch(() => {}); });
    backgrounds = [];
    if (lastTrigger?.isConnected) lastTrigger.focus({ preventScroll: true });
  }
  function setupPlayer() {
    dialog = document.getElementById('SykCreatorDialog');
    if (!dialog || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    player = dialog.querySelector('[data-creator-player]');
    dialog.querySelector('[data-creator-close]').addEventListener('click', closePlayer);
    dialog.addEventListener('click', event => { if (event.target === dialog) closePlayer(); });
    dialog.addEventListener('close', restorePage);
    player.addEventListener('error', () => { if (dialog.open && player.getAttribute('src')) dialog.querySelector('[data-creator-error]').hidden = false; });
    const visibility = new IntersectionObserver(entries => {
      if (dialog.open && entries.some(entry => entry.intersectionRatio < 0.1)) player.pause();
    }, { root: dialog, threshold: 0.1 });
    visibility.observe(player);
    dialog.querySelector('[data-creator-shop]').addEventListener('click', event => {
      const link = event.currentTarget;
      if (new URL(link.href, location.href).pathname !== location.pathname) return;
      event.preventDefault();
      closePlayer();
      document.getElementById('SykBuy')?.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    });
    document.addEventListener('visibilitychange', () => { if (document.hidden && dialog.open) player.pause(); });
  }
  function playFilm(trigger) {
    setupPlayer();
    if (!dialog || !player || !trigger.dataset.videoSrc || typeof dialog.showModal !== 'function') return false;
    stopPlayer();
    lastTrigger = trigger;
    const { videoSrc, poster, productTitle, productUrl, productPrice, creator, source } = trigger.dataset;
    dialog.querySelector('[data-creator-title]').textContent = productTitle;
    const sameProductPage = new URL(productUrl, location.href).pathname === location.pathname;
    dialog.querySelector('[data-creator-price]').textContent = sameProductPage ? (document.querySelector('[data-variant-price]')?.textContent || productPrice) : productPrice;
    const profile = dialog.querySelector('[data-creator-profile]');
    profile.textContent = `@${creator}`;
    profile.href = `https://www.tiktok.com/@${encodeURIComponent(creator)}`;
    dialog.querySelector('[data-creator-original]').href = source;
    dialog.querySelector('[data-creator-shop]').href = productUrl;
    dialog.querySelector('[data-creator-error]').hidden = true;
    backgrounds = [...document.querySelectorAll('video[data-brand-video]')].filter(video => !video.paused);
    backgrounds.forEach(video => video.pause());
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    scrollLocked = true;
    player.poster = poster;
    player.src = videoSrc;
    player.muted = false;
    player.load();
    if (!dialog.open) dialog.showModal();
    player.play().catch(() => { /* Native controls remain available if autoplay is blocked. */ });
    return true;
  }
  function setupLibrary(root) {
    if (instances.has(root)) return;
    const events = new AbortController();
    const options = { signal: events.signal };
    const cards = [...root.querySelectorAll('[data-creator-card]')];
    const rail = root.querySelector('[data-creator-cards]');
    if (!cards.length || !rail) { root.hidden = true; return; }
    let activeFilter = 'all', visibleLimit = Number(root.dataset.pageSize) || 8;
    const pageSize = visibleLimit;
    const more = root.querySelector('[data-creator-more]');
    const count = root.querySelector('[data-creator-count]');
    function updateWall() {
      let displayed = 0;
      const matched = cards.filter(card => activeFilter === 'all' || card.dataset.category === activeFilter);
      cards.forEach(card => {
        const matches = activeFilter === 'all' || card.dataset.category === activeFilter;
        card.hidden = !matches || displayed >= visibleLimit;
        if (matches && !card.hidden) displayed += 1;
      });
      if (more) more.hidden = displayed >= matched.length;
      if (count) count.textContent = `${displayed} of ${matched.length} films`;
    }
    if (root.dataset.mode === 'wall') {
      root.querySelector('[data-creator-tools]').hidden = false;
      root.querySelectorAll('[data-creator-filter]').forEach(button => button.addEventListener('click', () => {
        activeFilter = button.dataset.creatorFilter;
        visibleLimit = pageSize;
        root.querySelectorAll('[data-creator-filter]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        updateWall();
      }, options));
      more?.addEventListener('click', () => { visibleLimit += pageSize; updateWall(); }, options);
      updateWall();
    } else {
      const controls = root.querySelector('[data-creator-controls]');
      const prev = root.querySelector('[data-creator-prev]'), next = root.querySelector('[data-creator-next]');
      function updateArrows() {
        const overflow = rail.scrollWidth > rail.clientWidth + 3;
        if (controls) controls.hidden = !overflow;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
      }
      prev?.addEventListener('click', () => rail.scrollBy({left:-rail.clientWidth*.85,behavior:reducedMotion()?'auto':'smooth'}), options);
      next?.addEventListener('click', () => rail.scrollBy({left:rail.clientWidth*.85,behavior:reducedMotion()?'auto':'smooth'}), options);
      rail.addEventListener('scroll', updateArrows, {...options,passive:true});
      const observer = new ResizeObserver(updateArrows);
      observer.observe(rail);
      events.signal.addEventListener('abort', () => observer.disconnect(), {once:true});
      updateArrows();
    }
    root.querySelectorAll('[data-creator-play]').forEach(trigger => trigger.addEventListener('click', event => {
      if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      if (playFilm(trigger)) event.preventDefault();
    }, options));
    instances.set(root, events);
  }
  function setup(scope = document) {
    setupPlayer();
    scope.querySelectorAll('[data-creator-library]').forEach(setupLibrary);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), {once:true});
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-creator-library]').forEach(root => { instances.get(root)?.abort(); instances.delete(root); });
    if (dialog?.open) closePlayer();
  });
  window.sykCreatorFilms = { refresh: () => setup(), close: closePlayer };
})();
